<div class="address-form container flex justify-center flex-column">
  <p>Complete the address details below.</p>
  <form [formGroup]="formGroup" id="address-form">
    <div class="row-inputs-container flex justify-between flex-row">
      <div class="input-50">
        <mat-form-field appearance="fill" class="w-100 flex-1">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" type="text" />
        </mat-form-field>
      </div>
      <div class="input-50">
        <mat-form-field appearance="fill" class="w-100 flex-1">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" type="text" />
        </mat-form-field>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-label>Area</mat-label>
      <input matInput formControlName="area" type="text" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Building name</mat-label>
      <input matInput formControlName="buildingNumber" type="text" autofocus />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Apartment/Vila/Townhouse number</mat-label>
      <input matInput formControlName="apartmentNumber" type="text" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Makani number (optional)</mat-label>
      <input matInput formControlName="makaniNumber" type="text" />
    </mat-form-field>
    <mat-radio-group class="flex w-100 justify-between" formControlName="name">
      <mat-radio-button value="Office">Office</mat-radio-button>
      <mat-radio-button value="Home">Home</mat-radio-button>
      <mat-radio-button value="">Don't Save</mat-radio-button>
    </mat-radio-group>
    <button type="button" class="primary-button" (click)="save()">
      Confirm Address
    </button>
    <button type="button" class="secondary-button" (click)="backToMap()">
      No, I need to change
    </button>
  </form>
</div>
